import routes from './routes';
import { SetRoutes } from 'components';

const KpiPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default KpiPages;
